<template>
    <div>
        <b-modal
            id="switchUserModal"
            ref="switchUserModal"
            :lazy="true"
            title-tag="h2"
            title="Switch User"
        >
            <form class="form-horizontal">
                <div class="form-group row">
                    <label for="current" class="col-sm-3 col-form-label"
                        >Staff:</label
                    >
                    <div class="col-sm-9">
                        <v-select
                            id="staff"
                            ref="vselect"
                            :options="staff_options_exclude"
                            v-model="data.staff"
                            :label="'fullname'"
                            v-validate="'required'"
                            name="staff"
                            placeholder="Staff name (required)"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="new" class="col-sm-3 col-form-label"
                        >Password:</label
                    >
                    <div class="col-sm-9">
                        <input
                            id="password"
                            v-model="data.password"
                            v-validate="'required'"
                            :class="{ 'border-danger': errors.has('new') }"
                            type="password"
                            class="form-control"
                            name="password"
                            placeholder="Current password (required)"
                        />
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.switchUserModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="doSwitch" v-else variant="primary"
                        >Sign In</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import vSelect from "vue-select";

export default {
    components: {
        vSelect
    },
    data() {
        return {
            data: {
                staff: null,
                staff_id: null,
                password: null
            },
            staffList: [],
            loading: false
        };
    },
    computed: {
        staff_options_exclude() {
            return _.difference(this.staffList, this.data.staff);
        }
    },
    methods: {
        open() {
            this.getStaffList();

            this.$refs.switchUserModal.show();
        },
        getStaffList() {
            let self = this;
            this.$http
                .get(process.env.ACTOR_SERVICE + "staff?getAll=1")
                .then(function (response) {
                    self.staffList = response.data.response.resource;
                });
        },
        doSwitch() {
            let self = this;

            self.loading = true;

            let post = {
                // vettersession: localStorage.getItem('vettersession'),
                staff_id: self.data.staff.id,
                old_staff_id: this.$root.currentActor.id,
                password: self.data.password
            };
            return (
                $
                    // .post(process.env.ACTOR_SERVICE + "staff/switch-user", post)
                    .post(
                        process.env.APPS + "index.php/ajax/staff/do_switch",
                        post
                    )
                    .then(function (response) {
                        if (response.data.response.message.code == 200) {
                            if (response.data.response.resource.message)
                                self.$root.$emit(
                                    "message",
                                    response.data.response.resource.message,
                                    "success"
                                );

                            self.$refs.switchUserModal.hide();
                        } else {
                            self.$root.$emit(
                                "message",
                                response.data.response.resource.message,
                                "danger"
                            );
                        }
                    })
                    .finally(() => (self.loading = false))
            );
        }
    }
};
</script>
